<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      {{ editingId ? $t('navigations.update cra') : $t('navigations.assign cra') }}
    </template>

    <template #body>
      <!-- <div v-if="isEditMode" class="text-center py-5">
        <div class="text-center">
          <h2>
            loading...
          </h2>
          <img src="../../assets/img/loading.gif" width="15" alt="Waiting" />
        </div>
      </div> -->
      <div  class="row">

        <!-- Role -->
        <!-- <div class="col-12 col-md-6 mb-2">
          <label class="form-label">{{ $t("navigations.role") }}</label>
          <select class="form-control"
                  v-model="craDetails.roleId"
                  @change="onRoleChange">
            <option value="">Select</option>
            <option v-for="role in roleList"
                    :key="role.roleID"
                    :value="role.roleID">
              {{ role.roleName }}
            </option>
          </select>
          <span v-if="formErrors.role" class="text-danger">{{ formErrors.role }}</span>
        </div> -->

        <!-- CRA -->
        <div class="col-12 col-md-6 mb-2">
          <label class="form-label">{{ $t("navigations.cra") }}</label>&nbsp;
          <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup>
          <select class="form-control" v-model="craDetails.craEmail">
            <option value="">Select</option>
            <option v-for="user in userList" :key="user.email" :value="user.email">
              {{ user.email }}
            </option>
          </select>
          <span v-if="formErrors.cra" class="text-danger">{{ formErrors.cra }}</span>
        </div>

        <!-- Site -->
        <div class="col-12 col-md-6 mb-2"  v-if="!editingId">
          <label>Sites</label>&nbsp;
          <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup>
          <select class="form-control" v-model="newCra.siteId">
            <option value="">Select</option>
            <option v-for="site in sites" :key="site.siteID" :value="site.siteID">
              {{ site.siteCode }}
            </option>
          </select>
          <span v-if="formErrors.sites" class="text-danger">{{ formErrors.sites }}</span>
        </div>

        <!-- Planned Date -->
        <div class="col-12 col-md-6 mb-2">
          <label>{{ $t("navigations.planned date") }}</label>&nbsp;
          <sup class="text-danger"><i class="fa fa-asterisk imp"></i></sup>
          <input type="date" class="form-control" v-model="newCra.plannedDate" />
          <span v-if="formErrors.plannedDate" class="text-danger">
            {{ formErrors.plannedDate }}
          </span>
        </div>

     

        <!-- Visit Type -->
        <div class="col-12 col-md-6 mb-2" v-if="!editingId">
          <label>Visit Type</label>
          <select class="form-control" v-model="newCra.visitType" @change="onVisitTypeChange">
            <option value="">Select</option>
            <option v-for="type in visitTypes" :key="type" :value="type">
              {{ type }}
            </option>
          </select>
          <span v-if="formErrors.visitType" class="text-danger">
            {{ formErrors.visitType }}
          </span>
        </div>

        <div class="col-12 col-md-6 mb-2" v-if="!editingId">
          <label>Visit Name</label>
          <input type="text" class="form-control" v-model="newCra.visitName" />
        </div>

        <!-- Checklist Multiselect -->
        <div class="col-12 col-md-6 mb-2" v-if="!editingId">
          <label>Checklist</label>
          <Multiselect 
            v-model="newCra.checklist" 
            mode="multiple" 
            :searchable="true"
            placeholder="Select Checklist items"
            :options="checklists" 
            :hideSelected="false"
            :closeOnSelect="false" 
            class="multiselect-theme">
          </Multiselect>
        </div>

        <!-- Monitoring Mode -->
        <div class="col-12 col-md-6 mb-2" v-if="!editingId">
          <label>{{ $t("navigations.monitoring mode") }}</label>
          <select class="form-control" v-model="newCra.monitoringMode">
            <option value="">Select</option>
            <option v-for="mode in monitoringModeOptions" :key="mode" :value="mode">
              {{ mode }}
            </option>
          </select>
        </div>

        <!-- Triggered By -->
        <div class="col-12 col-md-6 mb-2" v-if="!editingId">
          <label>{{ $t("navigations.reason") }}</label>
          <select class="form-control" v-model="newCra.triggeredBy">
            <option value="">Select</option>
            <option v-for="trigger in triggeredByOptions" :key="trigger" :value="trigger">
              {{ trigger }}
            </option>
          </select>
        </div>
            <!--  Comment box when Others is selected -->
             <div class="col-12 col-md-12 mb-2" v-if="newCra.triggeredBy === 'Others'">
                <label for="triggeredByComment">
                  Please specify the reason
                </label>
                <textarea id="triggeredByComment" class="form-control" rows="3"
                  v-model="newCra.Comment" placeholder="Please specify the reason" required></textarea>
              </div>
        <div class="col-12 col-md-6 mb-2" >
          <label>Status</label>
          <select v-model="newCra.status" class="form-control" >
            <option value="">Select</option>
            <option value="Planned">Planned</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Rescheduled">Rescheduled</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>


        <!-- Repeat Period -->
        <div class="col-12 mb-2" v-if="showRepeatPeriod">
          <label class="fw-bold">{{ $t("navigations.repeat period") }}</label>
          <div class="row">
            <div class="col-md-4">
              <label >{{ $t("navigations.occurrence") }}</label>
              <select class="form-control" v-model="newCra.unit">
                <option value="">Select unit</option>
                <option value="DAY">Days</option>
                <option value="MONTH">Months</option>
                <option value="YEAR">Years</option>
              </select>
            </div>
            <div class="col-md-4">
              <label >{{ $t("navigations.interval") }}</label>
              <input type="number" min="0" class="form-control" placeholder="Enter value" v-model="newCra.value" />
            </div>
               <!-- End Date -->
        <div class="col-md-4">
          <label>{{ $t("navigations.end date") }}</label>
          <input type="date" class="form-control" v-model="newCra.endDate" />
        </div>
          </div>
        </div>
      </div>

      <div class="text-end mt-3">
        <button class="save_btn px-4 py-1"  @click="editingId ? updateCraSchedule() : submitCraSchedule()">
          {{ editingId ? 'Update' : 'Create' }}

        </button>
      </div>
    </template>
  </customModal>
</template>


<script src="./CraAddEditModal.js"></script>
<style scoped>
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

.text-danger {
  color: red;
}
</style>